import { Box, Flex, Heading, Text, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/ui/button";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

import SuccessImage from "../assets/images/success.png";

export const Success = () => {
  const navigate = useNavigate();

  const calculatedHeight = `calc(100vh - 70px)`;

  return (
    <Box>
      <Header dark={false} />

      <Box borderTopWidth={"1px"} borderColor={"#E8E9EA"}>
        <Flex
          bg="white"
          h={calculatedHeight}
          align={"center"}
          justify={"center"}
          justifySelf={"center"}
          maxW={{ base: "100%", md: "375px" }}
          p="16px"
          flexDir={"column"}
        >
          <Image src={SuccessImage} w="73px" mb="32px" />

          <Heading
            fontSize={{ base: "19px", md: "28px" }}
            color={"#1E1C24"}
            fontFamily={"DMSans-Medium"}
          >
            Message Delivered
          </Heading>

          <Text
            fontSize={"16px"}
            color={"#64748B"}
            textAlign={"center"}
            mt="8px"
            mb="32px"
            px={{ base: "60px", md: 0 }}
            fontFamily={"Sora-Regular"}
          >
            Thanks for reaching out! We've received your message and will get
            back to you soon.
          </Text>

          <Button w="100%" onClick={() => navigate("/")}>
            Home
          </Button>
        </Flex>
      </Box>

      <Footer />
    </Box>
  );
};
